// extracted by mini-css-extract-plugin
module.exports = {"main":"Location_main__2uiMk","icon":"Location_icon__kOMIc","skeleton":"Location_skeleton__18y-G"};